<div class="max-h-[100dvh]">
  <!-- Skip link: first focusable element; lets keyboard users jump past the
       header straight to the page content (WCAG 2.4.1 Bypass Blocks). -->
  <a
    href="#main-content"
    class="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:text-dark focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-dark dark:focus:ring-white dark:focus:bg-surface-dark dark:focus:text-white"
  >
    Skip to main content
  </a>
  <app-mfa-required-overlay />
  <app-ai-help />
  <div class="flex w-full h-full">
    <div
      class="h-full w-full min-h-[100dvh] bg-no-repeat bg-[center_center] bg-cover relative bg-muted dark:bg-page-dark transition-colors"
    >
      <div class="flex w-full h-full items-center justify-center relative overflow-visible">
        <div
          class="relative w-full h-full min-h-[100dvh] z-[1] transition-transform flex flex-col justify-between"
        >
          <div class="">
            <app-header></app-header>
            <main id="main-content" tabindex="-1" class="focus:outline-none">
              <router-outlet class="hidden"></router-outlet>
            </main>
          </div>
          <app-footer></app-footer>
        </div>
      </div>
    </div>
  </div>
</div>
